import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import storeJS from 'store';

import LoadingScreen from 'components/Shared/LoadingScreen';
import Button from 'uikit/Button';

import Empty from './Empty';
import TestSessionCard from './TestSessionCard';
import styles from './TestResults.module.scss';

const cx = classNames.bind(styles);

const TestResults = ({
  className,
  course,
  handleGradeSynchronize,
  isEmpty,
  isLoading,
  t,
}) =>
  isLoading ? (
    <LoadingScreen />
  ) : (
    <div className={cx('container', className)}>
      <div className={cx('header')}>
        <h3 className={cx('title')}>
          {t('Course/Teacher/TestResults/title')}
          <span className={cx('count')}>{course.testSessions.length}</span>
        </h3>
        <div>
          {course.moodle.isMoodle && !isEmpty && (
            <Button
              className={cx('lms')}
              intent="primary"
              onClick={handleGradeSynchronize}
            >
              {t('Course/Teacher/TestResults/moodle-grade-sync')}
            </Button>
          )}
          <Button
            as="a"
            className={cx('action')}
            href={`${
              process.env.REACT_APP_API_URL
            }/rest/test/results-excel?courseId=${
              course.id
            }&authToken=${storeJS.get('token')}`}
            icon="download"
            intent="white"
            target="blank"
          >
            {t('Course/Teacher/ExamResults/download')}
          </Button>
        </div>
      </div>
      {isEmpty && <Empty />}
      {course.testSessions.map((testSession) => (
        <TestSessionCard
          className={cx('testSession')}
          key={testSession.id}
          testSession={testSession}
          testSessions={course.testSessions}
        />
      ))}
    </div>
  );

TestResults.propTypes = {
  className: PropTypes.string,
  course: PropTypes.object,
  handleGradeSynchronize: PropTypes.func.isRequired,
  isEmpty: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

TestResults.defaultProps = {
  className: undefined,
  course: undefined,
};

export default TestResults;
